module.exports = __webpack_public_path__ + "resources/icon_32_alert_warning.7c0baf6e33af5ecf.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_32_alert_warning.png
// module id = 449
// module chunks = 0 1 2 3 4